import React, { useEffect, useState } from "react";
import axios from "axios";
import { getOnlyToken } from '../../utils/commonFunctions';
import { useForm } from "react-hook-form";
import { Offcanvas, Modal, Button } from "react-bootstrap";
import DataTable, { createTheme } from 'react-data-table-component';
import { createThemeData, customStyles } from './../../utils/Constants'
const Users = () => {
    const [showPopup, setshowPopup] = useState(false);
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [roles, setRoles] = useState([]);

    const [menuPermissions, setMenuPermissions] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const { register, handleSubmit, reset, setValue, formState: { errors }, watch, trigger } = useForm({
        mode: 'onChange'
    });
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [editingUserId, setEditingUserId] = useState(null);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectAll, setSelectAll] = useState({
        view: false,
        add: false,
        edit: false,
        delete: false,
        download: false
    });
    createTheme('solarized', createThemeData, 'dark');

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => (page - 1) * perPage + index + 1,
            width: '80px',
        },
        {
            name: 'Name',
            selector: (row) => row.role_name || '--',
            sortable: true,
        },
        {
            name: 'Username',
            selector: (row) => row.username || '--',
        },
        {
            name: 'Email',
            selector: (row) => row.email || '--',
        },
        {
            name: 'Phone',
            selector: (row) => row.phone || '--',
        },
        {
            name: 'Role',
            selector: (row) => row.role_name || '--',
        },
        {
            name: 'Action',
            cell: (row) => (
                <div className="col-auto">
                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => handleEdit(row.id)}>
                        <i className="ri-edit-box-line"></i>
                    </button>
                    <button className="btn btn-link text-danger btn-lg p-0" onClick={() => handleDelete(row.id)}>
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const fetchMenuPermissions = async (roleId) => {
        if (!roleId) return;
        try {
            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await axios.get(`/api/sub_user/role_menu_permissions/${roleId}`, config);
            if (response.data?.results) {
                const filtered = response.data.results.map(menu => {
                    const hasDownload = menu.page_action && menu.page_action.download === 1;
                    return {
                        ...menu,
                        permissions: {
                            view: menu.permissions.view || false,
                            add: menu.permissions.add || false,
                            edit: menu.permissions.edit || false,
                            delete: menu.permissions.delete || false,
                            download: menu.permissions.download || false,
                        }
                    };
                });
                setMenuPermissions(filtered);
            }
        } catch (error) {
            console.error("Failed to fetch menu permissions", error);
        }
    };


    const fetchUserPermissions = async (roleId = selectedRoleId) => {
        try {
            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await axios.get(`/api/sub_user/role_menu_permissions/${roleId}`, config);
            if (response.data?.results) {
                setMenuPermissions(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching user permissions", error);
        }
    };




    const renderPermissionButton = (type) => {
        const config = {
            view: { class: "btn-outline-success", icon: "ri-eye-line", label: "View" },
            add: { class: "btn-outline-info", icon: "ri-add-box-line", label: "Add" },
            edit: { class: "btn-outline-warning", icon: "ri-edit-box-line", label: "Edit" },
            delete: { class: "btn-outline-danger", icon: "ri-delete-bin-line", label: "Delete" },
            excel_export: { class: "btn-outline-primary", icon: "ri-download-2-line", label: "Download" },
        };
        return config[type];
    };

    const fetchUsers = async (page = currentPage, pageSize = perPage) => {
        try {
            const token = getOnlyToken();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };

            const response = await axios.get(`/api/sub_user/get_sub_user_permission/?page=${page}&page_size=${pageSize}`, config);

            const result = response.data?.results || {};
            const data = result.data || []; // your users list
            const pagination = result.pagination || {};

            setUsers(data);
            setCurrentPage(pagination.current_page || page);
            setPerPage(pagination.per_page || pageSize);
            setTotalRows(pagination.total_posts || 0);

        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };


    useEffect(() => {
        fetchUsers(page, perPage);
    }, [page, perPage]);

    const handlePageChange = (page) => {
        fetchUsers(parseInt(page), parseInt(perPage));
    };

    const handlePerRowsChange = (newPerPage, page) => {
        fetchUsers(parseInt(page), parseInt(newPerPage));
    };


    const paginationComponentOptions = {
        rowsPerPageText: 'Rows per page:',
        rangeSeparatorText: 'of',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };


    const handleEdit = async (userId) => {
        setEditingUserId(userId);
        setshowPopup(true);
        try {
            const userResponse = await axios.get(`/api/sub_user/get_sub_user_permission/${userId}`);
            const userData = userResponse.data.results;
            if (userData) {
                setValue("firstName", userData.first_name);
                setValue("lastName", userData.last_name);
                setValue("username", userData.username);
                setValue("password", ""); // Leave password blank
                setValue("phone", userData.phone_number);
                setValue("roleId", userData.role_id);
                setSelectedRoleId(userData.role_id);
                if (userData.menus && Array.isArray(userData.menus)) {
                    setMenuPermissions(userData.menus.map(menu => ({
                        menu_id: menu.menu_id,
                        menu_name: menu.menu_name,
                        permissions: {
                            view: !!menu.permissions.view,
                            add: !!menu.permissions.add,
                            edit: !!menu.permissions.edit,
                            delete: !!menu.permissions.delete,
                            download: !!menu.permissions.download,
                        },
                    })));
                } else {
                    setMenuPermissions([]);
                }
            }
        } catch (error) {
            console.error("Error fetching user for edit:", error);
        }
    };

    const handleSelectAll = (permissionType) => {
        const newValue = !selectAll[permissionType];
        
        setSelectAll(prev => ({
            ...prev,
            [permissionType]: newValue
        }));

        setMenuPermissions(prev => 
            prev.map(menu => ({
                ...menu,
                permissions: {
                    ...menu.permissions,
                    [permissionType]: newValue,
                    // If unchecking view, uncheck all others
                    ...(permissionType === 'view' && !newValue ? {
                        add: false,
                        edit: false,
                        delete: false,
                        download: false
                    } : {})
                }
            }))
        );

        // Update other select all states if view is unchecked
        if (permissionType === 'view' && !newValue) {
            setSelectAll(prev => ({
                ...prev,
                add: false,
                edit: false,
                delete: false,
                download: false
            }));
        }
    };

    const handlePermissionToggle = (menuIndex, permissionType) => {
        setMenuPermissions((prev) => {
            const updated = [...prev];
            const menu = updated[menuIndex];

            // Toggle the permission
            const newValue = !menu.permissions[permissionType];
            menu.permissions[permissionType] = newValue;

            // If View is unchecked, remove all others
            if (permissionType === "view" && !newValue) {
                menu.permissions.add = false;
                menu.permissions.edit = false;
                menu.permissions.delete = false;
                menu.permissions.download = false;
            }

            updated[menuIndex] = { ...menu };

            // Update select all states based on current permissions
            const updatedSelectAll = {
                view: updated.every(m => m.permissions.view),
                add: updated.every(m => m.permissions.add),
                edit: updated.every(m => m.permissions.edit),
                delete: updated.every(m => m.permissions.delete),
                download: updated.every(m => m.permissions.download)
            };
            setSelectAll(updatedSelectAll);

            return updated;
        });
    };






    const handleDelete = async (userId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this user?");
        if (!confirmDelete) return;

        try {
            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.delete(`/api/sub_user/delete_sub_user_permission/${userId}/`, config);
            setSuccessMessage("User deleted successfully");
            setShowSuccessModal(true);
            fetchUsers();
        } catch (error) {
            console.error("Delete failed", error);
        }
    };

    const fetchRoles = async () => {
        try {
            const token = getOnlyToken();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };
            const response = await axios.get("https://callapi.pranathiss.com/api/sub_user/role-list/", config);
            if (response.data?.results) {
                setRoles(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };

    useEffect(() => {
        fetchRoles();
        fetchUsers(page);
    }, [page]);


    const onSubmit = async (data) => {
        try {
            // Validate that at least one menu permission is selected
            const hasPermissions = menuPermissions.some(menu => 
                menu.permissions.view || menu.permissions.add || 
                menu.permissions.edit || menu.permissions.delete || 
                menu.permissions.download
            );
            
            if (!hasPermissions) {
                alert("Please select at least one menu permission.");
                return;
            }

            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };

            // Extract permission-wise menu IDs
            const viewIds = [];
            const addIds = [];
            const editIds = [];
            const deleteIds = [];
            const downloadIds = [];

            menuPermissions.forEach(menu => {
                const { menu_id, permissions } = menu;
                if (permissions.view) viewIds.push(menu_id);
                if (permissions.add) addIds.push(menu_id);
                if (permissions.edit) editIds.push(menu_id);
                if (permissions.delete) deleteIds.push(menu_id);
                if (permissions.download) downloadIds.push(menu_id);
            });

            // Construct payload
            const payload = {
                first_name: data.firstName,
                last_name: data.lastName,
                username: data.username,
                email: data.email,
                password: data.password,
                phone: data.phone,
                role_id: selectedRoleId,
                parent_id: viewIds.join(","), 
                menu_id_view: viewIds.join(","),
                menu_id_add: addIds.join(","),
                menu_id_edit: editIds.join(","),
                menu_id_delete: deleteIds.join(","),
                menu_id_download: downloadIds.join(","),
            };

            // Determine create or update API
            const url = editingUserId
                ? `/api/sub_user/update_sub_user_permission/${editingUserId}/`
                : `/api/sub_user/create_sub_user_permission/`;

            const method = editingUserId ? axios.put : axios.post;

            // Make the request
            const response = await method(url, payload, config);

            if (response.data.error_code === 200) {
                setSuccessMessage(editingUserId ? "User updated successfully" : "User created successfully");
                setShowSuccessModal(true);
                reset();
                setshowPopup(false);
                setEditingUserId(null);
                fetchUsers(); // Refresh user list
            } else {
                console.error("Unexpected response:", response.data);
            }
        } catch (error) {
            console.error("Error saving user:", error);
        }
    };

    const handleAddNewUserClick = () => {
        setEditingUserId(null);
        reset();
        setSelectedRoleId("");
        setMenuPermissions([]);
        setSelectAll({
            view: false,
            add: false,
            edit: false,
            delete: false,
            download: false
        });
        setshowPopup(true);
    };

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="mb-3 d-flex flex-column flex-md-row-reverse align-items-start align-items-md-center justify-content-between gap-2">
                        <button type="button" className="btn btn-success mt-0 page-title-right" onClick={handleAddNewUserClick}>
                            <i className="ri-user-add-line"></i> Add New User
                        </button>

                        <div className="page-title-left">
                            <div className="app-search">
                                <form>
                                    <div className=" position-relative">
                                        <input type="text" className="form-control border border-dark border-opacity-10" placeholder="Search users..." />
                                        <span className="ri-search-line search-icon"></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <DataTable
                        title="Users"
                        columns={columns}
                        data={users}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationDefaultPage={currentPage}
                        paginationPerPage={perPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        theme="solarized"
                        customStyles={customStyles}
                    />

                </div>
            </div>

            <Offcanvas show={showPopup} onHide={() => setshowPopup(false)} style={{ width: '750px' }} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{editingUserId ? "Edit User" : "Add New User"}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row g-2">
                            <div className="mb-1 col-md-6">
                                <label className="form-label">First Name <span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    className={`form-control ${errors.firstName ? 'is-invalid' : ''}`} 
                                    {...register("firstName", {
                                        required: "First name is required",
                                        minLength: { value: 2, message: "First name must be at least 2 characters" },
                                        maxLength: { value: 50, message: "First name cannot exceed 50 characters" },
                                        pattern: { value: /^[A-Za-z\s]+$/, message: "First name should contain only letters" }
                                    })} 
                                    placeholder="First Name" 
                                />
                                {errors.firstName && <div className="invalid-feedback">{errors.firstName.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    className={`form-control ${errors.lastName ? 'is-invalid' : ''}`} 
                                    {...register("lastName", {
                                        required: "Last name is required",
                                        minLength: { value: 2, message: "Last name must be at least 2 characters" },
                                        maxLength: { value: 50, message: "Last name cannot exceed 50 characters" },
                                        pattern: { value: /^[A-Za-z\s]+$/, message: "Last name should contain only letters" }
                                    })} 
                                    placeholder="Last Name" 
                                />
                                {errors.lastName && <div className="invalid-feedback">{errors.lastName.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Username <span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    className={`form-control ${errors.username ? 'is-invalid' : ''}`} 
                                    {...register("username", {
                                        required: "Username is required",
                                        minLength: { value: 3, message: "Username must be at least 3 characters" },
                                        maxLength: { value: 30, message: "Username cannot exceed 30 characters" },
                                        pattern: { value: /^[a-zA-Z0-9_@#$%^&*()+=!.-]+$/, message: "Username can contain letters, numbers, underscores, and special characters" }
                                    })} 
                                    placeholder="Username" 
                                />
                                {errors.username && <div className="invalid-feedback">{errors.username.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Email <span className="text-danger">*</span></label>
                                <input 
                                    type="email" 
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`} 
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: { 
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 
                                            message: "Please enter a valid email address" 
                                        }
                                    })} 
                                    placeholder="Email" 
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Password <span className="text-danger">*</span></label>
                                <input 
                                    type="password" 
                                    className={`form-control ${errors.password ? 'is-invalid' : ''}`} 
                                    {...register("password", {
                                        required: "Password is required",
                                        minLength: { value: 8, message: "Password must be at least 8 characters" },
                                        pattern: { 
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, 
                                            message: "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character" 
                                        }
                                    })} 
                                    placeholder="Password" 
                                />
                                {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Phone Number <span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    className={`form-control ${errors.phone ? 'is-invalid' : ''}`} 
                                    {...register("phone", {
                                        required: "Phone number is required",
                                        pattern: { 
                                            value: /^(\+\d{1,3}\s?)?[6-9]\d{9}$/, 
                                            message: "Please enter a valid phone number (e.g., 9603429045 or +91 9603429045)" 
                                        },
                                        validate: {
                                            notAllSame: (value) => {
                                                const cleanNumber = value.replace(/\D/g, '');
                                                const lastTenDigits = cleanNumber.slice(-10);
                                                return !/^(\d)\1{9}$/.test(lastTenDigits) || "Phone number cannot have all same digits";
                                            }
                                        }
                                    })} 
                                    placeholder="Phone" 
                                />
                                {errors.phone && <div className="invalid-feedback">{errors.phone.message}</div>}
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Role <span className="text-danger">*</span></label>
                                <select
                                    className={`form-select ${errors.roleId ? 'is-invalid' : ''}`}
                                    value={selectedRoleId}
                                    {...register("roleId", {
                                        required: "Please select a role"
                                    })}
                                    onChange={(e) => {
                                        const roleId = e.target.value;
                                        setSelectedRoleId(roleId);
                                        setValue("roleId", roleId);
                                        trigger("roleId");
                                        fetchMenuPermissions(roleId);
                                    }}
                                >
                                    <option value="">Select Role</option>
                                    {roles.map((role) => (
                                        <option key={role.id} value={role.id}>
                                            {role.role_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.roleId && <div className="invalid-feedback">{errors.roleId.message}</div>}
                            </div>

                        </div>

                        <div>
                            <h5 className="mt-4">Menu Permissions <span className="text-danger">*</span></h5>
                            {menuPermissions.length === 0 && selectedRoleId && (
                                <div className="alert alert-warning">
                                    <i className="ri-information-line me-2"></i>
                                    No menu permissions available for the selected role.
                                </div>
                            )}
                            {!selectedRoleId && (
                                <div className="alert alert-info">
                                    <i className="ri-information-line me-2"></i>
                                    Please select a role first to view menu permissions.
                                </div>
                            )}
                            
                            {/* Select All Row */}
                            {menuPermissions.length > 0 && (
                                <div className="card mb-3">
                                    <div className="card-body py-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="fw-bold">
                                                <i className="ri-select-all-line me-2"></i>
                                                Select All
                                            </div>
                                            <div className="d-flex flex-wrap gap-3">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllView"
                                                        checked={selectAll.view}
                                                        onChange={() => handleSelectAll("view")}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="selectAllView">View</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllAdd"
                                                        checked={selectAll.add}
                                                        disabled={!selectAll.view}
                                                        onChange={() => handleSelectAll("add")}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="selectAllAdd">Add</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllEdit"
                                                        checked={selectAll.edit}
                                                        disabled={!selectAll.view}
                                                        onChange={() => handleSelectAll("edit")}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="selectAllEdit">Edit</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllDelete"
                                                        checked={selectAll.delete}
                                                        disabled={!selectAll.view}
                                                        onChange={() => handleSelectAll("delete")}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="selectAllDelete">Delete</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllDownload"
                                                        checked={selectAll.download}
                                                        disabled={!selectAll.view}
                                                        onChange={() => handleSelectAll("download")}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="selectAllDownload">Download</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            <ul className="list-group">
                                {menuPermissions.map((menu, index) => {
                                    const { menu_id, menu_name, menu_icons = "ri-menu-line", permissions, page_action = {} } = menu;
                                    return (
                                        <li key={menu_id} className="list-group-item d-flex justify-content-between align-items-start flex-column flex-md-row">
                                            <div className="mb-2">
                                                <i className={`${menu_icons} me-2`} />
                                                {menu_name}
                                            </div>
                                            <div className="d-flex flex-wrap gap-3">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`view-${index}`}
                                                        checked={permissions.view}
                                                        onChange={() => handlePermissionToggle(index, "view")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`view-${index}`}>View</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`add-${index}`}
                                                        checked={permissions.add}
                                                        disabled={!permissions.view}
                                                        onChange={() => handlePermissionToggle(index, "add")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`add-${index}`}>Add</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`edit-${index}`}
                                                        checked={permissions.edit}
                                                        disabled={!permissions.view}
                                                        onChange={() => handlePermissionToggle(index, "edit")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`edit-${index}`}>Edit</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`delete-${index}`}
                                                        checked={permissions.delete}
                                                        disabled={!permissions.view}
                                                        onChange={() => handlePermissionToggle(index, "delete")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`delete-${index}`}>Delete</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`download-${index}`}
                                                        checked={permissions.download}
                                                        disabled={!permissions.view}
                                                        onChange={() => handlePermissionToggle(index, "download")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`download-${index}`}>Download</label>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>



                        <div className="mt-4 text-end">
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                                disabled={Object.keys(errors).length > 0}
                            >
                                {editingUserId ? "Update User" : "Create User"}
                            </button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>

            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>{successMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>


        </>
    )
}

export default Users;